module.exports = __webpack_public_path__ + "static/media/Diabetes_ensiapu_2016.a1712dc2.pdf";